import { render } from "./DataSelection.vue?vue&type=template&id=bd408f72&scoped=true"
import script from "./DataSelection.vue?vue&type=script&lang=js"
export * from "./DataSelection.vue?vue&type=script&lang=js"

import "./DataSelection.vue?vue&type=style&index=0&id=bd408f72&scoped=true&lang=css"

import exportComponent from "/home/runner/work/GPSviaAIS/GPSviaAIS/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd408f72"]])

export default __exports__